import React, { useState } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Select, { components } from "react-select";
import Avatar from "../../Avatar/Avatar";
import Line from "../../Line/Line";
import SpinnerLoader from "../../PageLoader/SpinnerLoader";
import { toast } from "react-toastify";
import {
  useGetPayrollPolicy,
  useAssignPayrollPolicy,
  useViewSalaryTemplateDetails,
} from "../../../queries/payrollQuries";

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <span className="ico-down text-blue-600"></span>
  </components.DropdownIndicator>
);

const AssignPayrollPolicy = ({ open, close, employee }) => {
  const employeeName = `${employee?.first_name} ${employee?.last_name}`;
  const employeeSerial = employee?.employee_serial;
  const department = employee?.department_name;
  const roleName = employee?.role_name;
  const employeePhoto = employee?.photo;
  const employeeId = employee?.employee_id;
  const currentPayrollPolicy = employee?.payroll_policy_name;
  const autoCalculationType = 5;
  const percentageCalculationType = 2;
  const [errMsg, setErrMsg] = useState("");
  const [selectedPolicy, setSelectedPolicy] = useState(null);

 const { data, isLoading: isLoadingPolicies } = useGetPayrollPolicy({ is_active: true });

  const payrollPolicies = data?.data || [];
  const {
    data: policyDetails,
    isLoading: isLoadingPolicyDetails,
    error: policyDetailsError,
  } = useViewSalaryTemplateDetails(
    selectedPolicy ? { policy_id: selectedPolicy } : {}
  );
;
  const assignPayrollPolicyMutation = useAssignPayrollPolicy();

  const handleCloseModal = () => {
    close();
  };

  const disableUpdateButton =
    assignPayrollPolicyMutation.isLoading || !selectedPolicy;

  const handleSubmit = () => {
    if (selectedPolicy) {
      setErrMsg("");
      const payload = {
        payroll_policy_id: selectedPolicy,
        employees: [{ employee_id: employeeId }],
      };

      assignPayrollPolicyMutation.mutate(payload, {
        onSuccess: (data) => {
          if (data?.status) {
            toast.success(
              data?.message || "Payroll policy assigned successfully!"
            );
            handleCloseModal();
          } else {
            toast.error(
              data?.message ||
                "Something went wrong while assigning payroll policy"
            );
          }
        },
        onError: (error) => {
          const errorMessage =
            error?.response?.data?.message ||
            "Something went wrong while assigning payroll policy";
          toast.error(errorMessage);
        },
      });
    } else {
      toast.error("Select a payroll policy");
    }
  };

  const handleDropdownChange = (selectedOption) => {
    setSelectedPolicy(selectedOption.value);
  };

  return (
    <Modal open={open} onClose={handleCloseModal} center>
      <div className="p-5 min-w-[420px] text-black">
        <h1 className="text-base font-medium">Assign Payroll Policy</h1>
        <Line />
        <div className="flex flex-col gap-3">
          <div className="flex items-center gap-3">
            <Avatar image={employeePhoto} />
            <span className="text-base font-medium">{employeeName}</span>
          </div>
          <div className="flex justify-between">
            <ul className="text-gray-600">
              <li>Employee serial:</li>
              <li>Department:</li>
              <li>Role:</li>
              <li>Current Payroll Policy:</li>
            </ul>
            <ul>
              <li>{employeeSerial || "-"}</li>
              <li>{department || "-"}</li>
              <li>{roleName || "-"}</li>
              <li>{currentPayrollPolicy || "-"}</li>
            </ul>
          </div>

         <div>
  {isLoadingPolicies ? (
    <div className="flex items-center gap-2 py-4">
      <SpinnerLoader size="small" />
      <span className="text-sm text-gray-600">Loading payroll policies...</span>
    </div>
  ) : payrollPolicies.length > 0 ? (
    <>
      <p className="py-4 text-sm font-medium">Select payroll policy:</p>
      <Select
        options={payrollPolicies.map((item) => ({
          label: item.policy_name,
          value: item.id,
        }))}
        onChange={handleDropdownChange}
        placeholder="Select a policy"
      />

      {selectedPolicy && (
        <div className="mt-4">
          {isLoadingPolicyDetails ? (
            <SpinnerLoader />
          ) : policyDetailsError ? (
            <span className="text-red-600 font-medium">
              Failed to load policy details
            </span>
          ) : policyDetails?.data?.length ? (
            <div className="border rounded-md p-2 shadow-md">
              <label className="font-medium">Payroll Policy Details:</label>
              {policyDetails.data.map((item, index) => (
                <ul
                  className="flex justify-between py-1 text-sm"
                  key={index}
                >
                  <li>{item.earning_type}</li>
                  <li>
                    {item.calculation_type === Number(autoCalculationType)
                      ? "Auto Calculated"
                      : item.calculation_type ===
                        Number(percentageCalculationType)
                      ? `${item.to_be_calculated_value}%`
                      : `${item.to_be_calculated_value}`}
                  </li>
                </ul>
              ))}
            </div>
          ) : (
            <span className="text-red-600 font-medium">
              Selected policy has no defined salary components
            </span>
          )}
        </div>
      )}
    </>
  ) : (
    <span className="text-red-600 font-medium">
      Create payroll policy to assign
    </span>
  )}
</div>


          <div className="flex justify-end gap-3 pt-4">
            <button
              type="button"
              className="btn btn--border"
              onClick={handleCloseModal}
            >
              Close
            </button>
            <button
              className={`btn text-[14px] pt-[11px] ${
                disableUpdateButton
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : ""
              } flex items-center justify-center`}
              onClick={handleSubmit}
              disabled={disableUpdateButton}
            >
              {assignPayrollPolicyMutation.isLoading ? (
                <>
                  <SpinnerLoader size="small" className="mr-2" /> Updating...
                </>
              ) : (
                "Update"
              )}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AssignPayrollPolicy;
